import type { AxiosError } from "axios";
import store from "@/store";
import { UPDATE_ERRORMSG } from "@/store/action-types";

/**
 * Handles network errors (no response from server) and timeout errors
 */
export function handleNetworkError(error: AxiosError): Promise<AxiosError> {
  // Handle timeout errors
  if (error.code === "ECONNABORTED") {
    store.dispatch(UPDATE_ERRORMSG, {
      errorMsg: "Request timeout. Please check your connection and try again.",
    });
    error._handled = true;
    return Promise.reject(error);
  }

  // Handle network errors (no response)
  const isSubscriptionActiveEndpoint = error.config?.url?.includes(
    "/subscription/organization/active"
  );

  if (!isSubscriptionActiveEndpoint) {
    const networkErrorMsg = "Network error. Please check your connection and try again.";
    const currentErrorMsg = store.getters.errorMsg;
    if (currentErrorMsg !== networkErrorMsg) {
      store.dispatch(UPDATE_ERRORMSG, {
        errorMsg: networkErrorMsg,
      });
    }
  }

  error._handled = true;
  return Promise.reject(error);
}
